export default __webpack_public_path__ + "static/media/download-file-excel.25159ea7.svg";